import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/hours-calculator',
  component: () => import('../../routes/HoursCalculator.svelte'),
  card: {
    id: 'hours-calculator',
    title: 'Hours Calculator',
    description: 'Calculate the duration between two times of day. Perfect for tracking work hours, billable time, and project duration.',
    icon: 'schedule',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/hours-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Hours Calculator – Calculate Time Duration Between Two Times',
    description:
      'Free hours calculator to calculate duration between two times of day. Track work hours, billable time, or project duration. Supports midnight crossings and multiple formats.',
  },
};

export default meta;
